import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	max-width: 50vw;
	min-width: 50vw;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;

	@media (min-width: 1100px) {
		min-width: 700px;
		max-width: 700px;
	}
`;

export const box = styled.div`
	width: 100%;
	height: 60vh;
	overflow: auto;
`;

export const forms = styled.div`
	width: 99.5%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
`;

export const twoInputsRow = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 650px) {
		flex-direction: column;
	}
`;

export const twoInputsColumn = styled.div<{
	$align?: 'center' | 'flex-start' | 'flex-end';
}>`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: ${(props) =>
		props.$align === undefined ? 'center' : props.$align};
	justify-content: space-between;

	@media (max-width: 650px) {
		flex-direction: column;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: fit-content;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;
